import { BitrixVue } from 'ui.vue';

BitrixVue.component('HingeCatalog', {
	data() {
		return {
			selectedColor: 0,
			defaultColor: {
				value: '/giper-config/assets/images/color-i5.jpg',
				title: 'цвет 1',
				type: 'image',
			},
		};
	},
	mounted() {
		this.defaultColor = this.items[this.selectedColor];
	},
	methods: {
		showModal(modal) {
			this.$refs[modal].open();
		},
		confirmSelection(modal) {
			this.$emit('modalItemSelect', this.selectedColor);
			this.$refs[modal].close();
			this.defaultColor = this.items[this.selectedColor]
		},
	},
	props: ['state', 'items'],
	template: `
<ConfigBlockWrap>
	<div class="config-color__modal-button">
		<Color :color="defaultColor" />
		<ButtonModal class="ml-20" buttonText="Изменить цвет" v-on:openModal="showModal('modal')" />
	</div>
	<ui-modal ref="modal" transition="fade" title="Цвет проема" class="hinge-modal config-modal" size="large">
		<ConfigBlockColors>
			<Color v-for="(color, index) of this.items" 
				:color="color"
				:class="{active: selectedColor === index}" 
				:key="index"
				v-on:setActiveColor="selectedColor = index" />
		</ConfigBlockColors>
		<div slot="footer">
				<ui-button @click="confirmSelection('modal')">Подтвердить</ui-button>
		</div>
	</ui-modal>
</ConfigBlockWrap>

`,
});
